<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up applicant_chk applicant_choice com_pop">
        <div class="pop_tit _flex">
            <p>{{ state.boardDetail.title }}</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>
        <div class="sch_condition_wrap">
            <div class="left _column">
                <div class="date_wrap">
                    <template v-if="state.boardDetail.state == 2">
                        <span class="state_tag">진행중</span>
                    </template>
                    <template v-else-if="state.boardDetail.state == 1">
                        <span class="state_tag waiting">대기중</span>
                    </template>
                    <template v-else>
                        <span class="state_tag finish">마감</span>
                    </template>
                    <div class="collection_period">
                        <span>
                            <img src="img/time_icon.png" alt="" />
                            모집기간
                        </span>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.boardDetail.recruitStartDate), ".") }}</span>
                        <em>-</em>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.boardDetail.recruitEndDate), ".") }}</span>
                    </div>
                    <div class="end_point">
                        <span>
                            <img src="img/time_icon.png" alt="" />
                            신청종료일
                        </span>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.boardDetail.applyDate), ".") }}</span>
                    </div>
                    <div class="activity_duration" v-if="state.boardDetail.activeStartDate && state.boardDetail.activeEndDate">
                        <span>
                            <img src="img/cal_icon.png" alt="" />
                            활동기간
                        </span>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.boardDetail.activeStartDate), ".") }}</span>
                        <em>-</em>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.boardDetail.activeEndDate), ".") }}</span>
                    </div>
                </div>
            </div>
            <div class="right _align_bottom">
                <button type="button" class="excel_btn icon_wrap" style="margin-top: 15px">
                    <img src="img/excel_icon.png" alt="" @click="downloadFile" />
                </button>
            </div>
        </div>
        <div class="list_container">
            <div class="common_table custom_scroll">
                <table>
                    <colgroup>
                        <col style="width: 80px" />
                        <col />
                        <col style="width: 60px" />
                        <col style="width: 150px" />
                        <col style="width: 170px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 40px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>번호</th>
                            <th>이름</th>
                            <th>성별</th>
                            <th>전화번호</th>
                            <th>신청일</th>
                            <th>신청서</th>
                            <th>상태</th>
                            <th>선발</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="state.list.length > 0">
                            <tr v-for="(item, idx) in state.list" :key="item.idx">
                                <td>{{ (state.page - 1) * state.size + (idx + 1) }}</td>
                                <td>{{ item.memberVO.memberVO.name }}</td>
                                <td>{{ strGender(item.memberVO.gender) }}</td>
                                <td>{{ CommonUtils.convertPhoneNumReal(item.memberVO.phone) }}</td>
                                <td>{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</td>
                                <td class="cnt p_5">
                                    <button type="button" class="table_btn _blue" @click="showAnswer(item)">보기</button>
                                </td>
                                <td class="cnt p_5">
                                    <p v-text="strState(item.state)"></p>
                                </td>
                                <td class="checkbox_wrap cnt p_5">
                                    <label :for="'chk_' + item.idx" @click.stop>
                                        <input type="checkbox" :id="'chk_' + item.idx" v-model="state.checkedList" :value="item.idx" @click.stop />
                                        <em></em>
                                    </label>
                                </td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="7"><div class="tb_subject" style="text-align: center; width: 100%">신청자가 없습니다.</div></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <PageBtn
            v-if="state.list.length !== 0"
            :currentPage="state.page"
            :totalLength="state.totalLength"
            :perPage="state.size"
            :data="state.data"
            @onPaging="handlePageChange"
        ></PageBtn>
        <div class="_flex _center btn_wrap">
            <button class="submit_btn _130 _main_blue" @click="save(3, state.idx)">임시저장</button>
            <button class="submit_btn _130 _main_blue" @click="save(2, state.idx)">최종선발</button>
        </div>
    </div>
    <AnswerModal
        v-if="state.isShowAnswer"
        :answerInfo="state.answerInfo"
        @close="state.isShowAnswer = false"
        @callback="
            state.isShowAnswer = false;
            getList();
        "
    ></AnswerModal>
</template>
<script lang="ts">
    import { onMounted, reactive, watch, onUnmounted, CommonUtils, apiService, types, getMessageByCode, PageBtn, AnswerModal } from "@/BaseComponent";

    export default {
        props: {
            idx: {
                type: Number,
                default: 0,
            },
        },
        emits: ["close", "save", "viewSign", "exportSign"],
        components: {
            PageBtn,
            AnswerModal,
        },
        setup(props: any, { emit }: any) {
            const state = reactive({
                idx: 0 as number,
                data: {},

                boardDetail: {} as any,

                list: {} as any,
                page: 1 as number,
                size: 20 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,

                modalTitle: "alert" as string,
                modalContent: "" as string,

                checkedList: [] as Array<string>,

                isShowAnswer: false as boolean,
                answerInfo: {} as any,
            });

            onMounted(() => {
                state.idx = props.idx;
                getList();
                boardDetail();
            });

            onUnmounted(() => {});

            const callBackModal = async (param: any) => {};

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const closeModal = () => {
                emit("close");
            };

            const getList = async () => {
                const param: types.ReqBoardApplyList = {
                    searchText: "",
                    searchType: "",
                    page: state.page,
                    size: state.size,
                    boIdx: state.idx,
                };

                const res = await apiService.board.listForApply(state.idx, param);
                if (res.returnCode === 0) {
                    state.list = res.list.data;
                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;

                    state.checkedList = state.list.filter((item: any) => item.state === 3).map((item: any) => item.idx);
                } else {
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };

            const boardDetail = async () => {
                const res = await apiService.board.detail(1, state.idx);

                if (res.returnCode === 0) {
                    state.boardDetail = res.data;
                }
            };

            const viewSign = async (param: string) => {
                emit("viewSign", param);
            };

            const exportSign = async (param: string) => {
                emit("exportSign", param);
            };

            const strGender = (val: string) => {
                switch (val) {
                    case "M":
                        return "남자";
                    case "F":
                        return "여자";
                    default:
                        return "기타";
                }
            };

            const strState = (val: number) => {
                switch (val) {
                    case 1:
                        return "대기중";
                    case 3:
                        return "임시선발";
                    case 2:
                        return "최종선발";
                    default:
                        return "";
                }
            };

            const save = async (type: number, idx: number) => {
                emit("save", type, idx, state.checkedList);
            };

            const showAnswer = (item: any) => {
                state.answerInfo = item;
                state.answerInfo.name = item.memberVO.memberVO.name;
                state.isShowAnswer = true;
            };

            const downloadFile = async () => {
                try {
                    let res = await apiService.board.exportExcelForApply(state.idx);
                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "파일 다운로드 실패";
                    state.isShowModal = true;
                }
            };

            return {
                state,
                closeModal,
                CommonUtils,
                save,
                handlePageChange,
                getList,
                strGender,
                strState,
                viewSign,
                callBackModal,
                exportSign,
                showAnswer,
                downloadFile,
            };
        },
    };
</script>
